export enum Chart {
  INITIALINVESTMENT = 'Initial Investment',
  ADDITIONALCONTRIBUTION = 'Additional Contribution',
  VALUECREATION = 'Value Creation',
}

export enum Frequency {
  Yearly = 'yearly',
  Monthly = 'monthly',
}

export enum PointOfContribution {
  Beginning = 'beginning',
  End = 'end',
}

export const chartData = [
  {
    id: Chart.INITIALINVESTMENT,
    data: [{ x: 0, y: 0 }],
  },
  {
    id: Chart.ADDITIONALCONTRIBUTION,
    data: [{ x: 0, y: 0 }],
  },
  {
    id: Chart.VALUECREATION,
    data: [{ x: 0, y: 0 }],
  },
];
